import React from 'react';
import { useTheme } from 'styled-components';
import PropTypes from 'prop-types';
import Spinner from '../Spinner';
import { SPINNER_DELAY } from '../Spinner/constants';
import Container, { LoadingSpinner } from './styles';
const SpinnerContainer = ({
  active = false,
  delay = SPINNER_DELAY,
  fixed = false,
  children = null
}) => {
  const theme = useTheme();
  return /*#__PURE__*/React.createElement(Container, {
    $active: active,
    $fixed: fixed,
    $delay: delay
  }, children, /*#__PURE__*/React.createElement(LoadingSpinner, {
    as: Spinner,
    $active: active,
    $fixed: fixed,
    $delay: delay,
    active: active,
    width: "2rem",
    height: "2rem",
    color: theme.palette.accentPrimary1
  }));
};
SpinnerContainer.propTypes = {
  active: PropTypes.bool,
  delay: PropTypes.number,
  children: PropTypes.node,
  fixed: PropTypes.bool
};
export default SpinnerContainer;
//# sourceMappingURL=index.js.map